import { sendText } from "../api/utils.js";
import { buildTrackingParams } from "./analytics.js";
const sendTextCallback = async (phoneNumber, axios, mainEntity, analyticsTrack, trackingParams, trackingEventName) => {
  const queryParams = buildTrackingParams({ trackingParams, mainEntity });
  const sourceMetaData = {};
  if ((mainEntity == null ? void 0 : mainEntity.type) === "product") {
    sourceMetaData.sku = mainEntity == null ? void 0 : mainEntity.entity.stacklineSku;
    sourceMetaData.brandId = mainEntity == null ? void 0 : mainEntity.entity.brandId;
  } else if ((mainEntity == null ? void 0 : mainEntity.type) === "brand") {
    sourceMetaData.brandId = parseInt(`${mainEntity == null ? void 0 : mainEntity.id}`);
  }
  const result = await sendText(axios, {
    phoneNumber,
    queryParams,
    source: (mainEntity == null ? void 0 : mainEntity.type) === "product" ? "productLandingPage" : (mainEntity == null ? void 0 : mainEntity.type) === "brand" ? "brandLandingPage" : "outerPage",
    sourceMetaData
  });
  if (analyticsTrack) {
    analyticsTrack(trackingEventName, {
      ...queryParams,
      phoneNumber
    });
  }
  return result;
};
export {
  sendTextCallback
};
//# sourceMappingURL=textMessage.js.map
